import React, { useState, useEffect } from "react";
import MusicListPlayer from "../../components/musicplayer/Musicplayer";
import { RightArrowWhite } from "../../assets/SvgIcons";
import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { fetchTracks } from "../../services/api";

const Portfolio = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [tracks, setTracks] = useState([]);

  useEffect(() => {
    fetchTracks()
      .then((data) => setTracks(data))
      .catch(() => {});
  }, []);

  return (
    <div className="portfolio">
      <div className="Portfolio-section" id="Portfolio">
        <h1 className="">{t("Portfolio")}</h1>
        <div className="d-flex justify-content-start align-items-center flex-column player-cards-wrapper mt-0">
          <MusicListPlayer tracks={tracks} />
          {/* added display:none for v1 */}
          <div className="player-card player-last-card" style={{ display: "none" }}>
            <div className="w-100 d-flex justify-content-between align-items-center gap-4">
              <div className="w-100 music-content">
                <p>{t("Created at Roger")}</p>
                <h3>{t("See more works")}</h3>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center align-items-center player-cards-wrapper">
          <div className="w-100 roger-token">
            <div className="roger-token-left-part">
              <h4 className="">{t("We are waiting for you at")}</h4>
              <h1 className="">Roger Sounds</h1>
              <p>
                {t("Hey! We have everything you need to make great music. Rehearsal, recording, rental – whatever! We're here and waiting for you.")}
              </p>
            </div>
            {/* added display:none for v1 */}
            <Button
              className="roger-token-right-btn"
              onClick={() => navigate("/booking")}
              style={{ display: "none" }}
            >
              <p>{t("Book")}</p>
              <RightArrowWhite />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Portfolio;
